import { render, staticRenderFns } from "./Partie12.vue?vue&type=template&id=3522add6&"
import script from "./Partie12.vue?vue&type=script&lang=js&"
export * from "./Partie12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports